<div class="spin" style="z-index: 10;" *ngIf="showLoader">
    <ion-spinner name="crescent"></ion-spinner>
</div>
<ion-app>
    <ion-router-outlet>
        <div class="spin">
            <ion-spinner name="crescent"></ion-spinner>
        </div>
    </ion-router-outlet>
</ion-app>